module.exports = __webpack_public_path__ + "static/funnels1-8413f6ead7bdc6a5e870c23933a47e26.png";